import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { PonchoUIModule } from '@poncho/ui';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-popover',
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.scss'],
    standalone: true,
    imports: [MatIconModule, PonchoUIModule]
})
export class PopoverComponent implements OnInit {

    @Output() isCtaClicked = new EventEmitter();
    @Output() isDismissed = new EventEmitter();

    constructor() {
    }

    ngOnInit() { }

    dismiss() {
        this.isDismissed.emit(true);
    }

    callToAction() {
        this.isCtaClicked.emit(true);
    }
}
